var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-6 bg-white rounded-lg"},[_c('div',{staticClass:"relative",staticStyle:{"padding-top":"75%"}},[_c('div',{ref:"powerbi",staticClass:"absolute pin"})])])}
var staticRenderFns = []

export { render, staticRenderFns }